// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --pink: #f2c4c4;
  --peach: #f9e1be;
  --mint: #bff1db;
  --lavender: #d5d1fd;

  --text: #3b3b55;
  --shadow: rgba(0, 0, 0, 0.08);
}

.education-loader {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

  /* White (or remove completely for transparent) */
  background: #ffffff;

  /* If you want transparent instead, use:
  background: transparent;
  */
}

/* ---------------- FLOATING EQUATIONS ---------------- */

.floating-elements{
    position:absolute;
    inset:0;
    overflow:hidden;
    pointer-events:none;
}

.equation {
  position: absolute;
  font-weight: 700;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;

  opacity: 0.32;

  text-shadow: 0 0 8px rgba(0, 0, 0, 0.03);

  animation-name: float;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}

/* Lavender */
.equation:nth-child(4n + 1) {
  color: #d5d1fd;
}

/* Mint */
.equation:nth-child(4n + 2) {
  color: #6bc79d;
}

/* Peach */
.equation:nth-child(4n + 3) {
  color: #e2b46a;
}

/* Pink */
.equation:nth-child(4n) {
  color: #e6a0a0;
}

@keyframes float {

  0% {
    transform: translateY(20px) rotate(-5deg);
    opacity: .22;
  }

  50% {
    transform: translateY(-20px) rotate(5deg);
    opacity: .55;
  }

  100% {
    transform: translateY(20px) rotate(-5deg);
    opacity: .22;
  }

}

/* ---------------- PARTICLES ---------------- */

.particles{

position:absolute;
inset:0;
pointer-events:none;

}

.particles span {

  width: 4px;
  height: 4px;

  border-radius: 50%;

  background: #d5d1fd;

  opacity: .35;

  box-shadow:
    0 0 8px rgba(213,209,253,.35);

  animation: particle linear infinite;

}

@keyframes particle{

0%{

transform:
translateY(0)
scale(.6);

opacity:0;

}

15%{

opacity:.8;

}

80%{

opacity:.8;

}

100%{

transform:
translateY(-130px)
scale(1.2);

opacity:0;

}

}

/* ---------------- CARD ---------------- */

.loader-card{

position:relative;
z-index:5;

width:430px;

padding:55px 45px;

border-radius:32px;

background:rgba(255,255,255,.72);

backdrop-filter:blur(20px);

border:1px solid rgba(255,255,255,.5);

box-shadow:

0 35px 70px rgba(0,0,0,.08),
0 12px 25px rgba(213,209,253,.30);

text-align:center;

}

/* ---------------- SPINNER ---------------- */

.math-spinner{

position:relative;

width:130px;
height:130px;

margin:auto;

animation:rotate 8s linear infinite;

}

.math-spinner::before{

content:"";

position:absolute;

inset:18px;

border-radius:50%;

background:

conic-gradient(

var(--lavender),
var(--mint),
var(--peach),
var(--pink),
var(--lavender)

);

filter:blur(16px);

opacity:.55;

animation:rotate 10s linear infinite reverse;

z-index:-1;

}

.math-spinner span{

position:absolute;

width:54px;
height:54px;

display:flex;
justify-content:center;
align-items:center;

border-radius:50%;

font-size:28px;
font-weight:700;

box-shadow:
0 10px 25px rgba(0,0,0,.12);

}

.math-spinner span:nth-child(1){

background:var(--lavender);
color:#5b4bc0;

top:0;
left:38px;

}

.math-spinner span:nth-child(2){

background:var(--mint);
color:#1f8160;

bottom:0;
left:38px;

}

.math-spinner span:nth-child(3){

background:var(--peach);
color:#bb7719;

left:0;
top:38px;

}

.math-spinner span:nth-child(4){

background:var(--pink);
color:#b35567;

right:0;
top:38px;

}

@keyframes rotate{

from{

transform:rotate(0deg);

}

to{

transform:rotate(360deg);

}

}

/* ---------------- CALCULATIONS ---------------- */

.number-counter {
  height: 40px;
  overflow: hidden;
  margin: 40px auto 20px;
  font-size: 30px;
  font-weight: 700;
  color: #5d56c6;
}

.number-track {
  animation: scrollCalc 12s infinite;
}

.number-track span {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
}

@keyframes scrollCalc {

  0%,10%   { transform: translateY(0); }

  15%,25%  { transform: translateY(-40px); }

  30%,40%  { transform: translateY(-80px); }

  45%,55%  { transform: translateY(-120px); }

  60%,70%  { transform: translateY(-160px); }

  75%,85%  { transform: translateY(-200px); }

  90%,100% { transform: translateY(-240px); }

}

/* ---------------- LOADING TEXT ---------------- */

.loading-text {
  height: 34px;
  overflow: hidden;
  margin-bottom: 26px;
  font-size: 24px;
  font-weight: 600;
  color: var(--text);
}

.message-track {
  animation: textScroll 15s infinite;
}

.message-track span {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
}

@keyframes textScroll {

  0%,18%   { transform: translateY(0); }

  20%,38%  { transform: translateY(-34px); }

  40%,58%  { transform: translateY(-68px); }

  60%,78%  { transform: translateY(-102px); }

  80%,100% { transform: translateY(-136px); }

}

/* ---------------- DOTS ---------------- */

.loading-dots{

display:flex;
justify-content:center;
gap:12px;

}

.loading-dots span{

width:12px;
height:12px;

border-radius:50%;

background:var(--lavender);

box-shadow:0 0 12px rgba(213,209,253,.7);

animation:bounce 1.5s infinite;

}

.loading-dots span:nth-child(2){

animation-delay:.2s;

}

.loading-dots span:nth-child(3){

animation-delay:.4s;

}

@keyframes bounce{

0%,80%,100%{

transform:translateY(0);
opacity:.45;

}

40%{

transform:translateY(-12px);
opacity:1;

}

}

/* ---------------- RESPONSIVE ---------------- */

@media (max-width:768px){

.loader-card{

width:90%;
padding:40px 25px;

}

.math-spinner{

transform:scale(.9);

}

.loading-text{

font-size:19px;

}

.number-counter{

font-size:22px;

}

.equation{

font-size:18px !important;

}

}`, "",{"version":3,"sources":["webpack://./src/components/Loader.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;;EAEnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;;EAEhB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,iDAAiD;EACjD,mBAAmB;;EAEnB;;GAEC;AACH;;AAEA,yDAAyD;;AAEzD;IACI,iBAAiB;IACjB,OAAO;IACP,eAAe;IACf,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;;EAEjB,aAAa;;EAEb,wCAAwC;;EAExC,qBAAqB;EACrB,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA,aAAa;AACb;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,cAAc;AAChB;;AAEA;;EAEE;IACE,yCAAyC;IACzC,YAAY;EACd;;EAEA;IACE,yCAAyC;IACzC,YAAY;EACd;;EAEA;IACE,yCAAyC;IACzC,YAAY;EACd;;AAEF;;AAEA,gDAAgD;;AAEhD;;AAEA,iBAAiB;AACjB,OAAO;AACP,mBAAmB;;AAEnB;;AAEA;;EAEE,UAAU;EACV,WAAW;;EAEX,kBAAkB;;EAElB,mBAAmB;;EAEnB,YAAY;;EAEZ;iCAC+B;;EAE/B,mCAAmC;;AAErC;;AAEA;;AAEA;;AAEA;;SAES;;AAET,SAAS;;AAET;;AAEA;;AAEA,UAAU;;AAEV;;AAEA;;AAEA,UAAU;;AAEV;;AAEA;;AAEA;;UAEU;;AAEV,SAAS;;AAET;;AAEA;;AAEA,2CAA2C;;AAE3C;;AAEA,iBAAiB;AACjB,SAAS;;AAET,WAAW;;AAEX,iBAAiB;;AAEjB,kBAAkB;;AAElB,gCAAgC;;AAEhC,0BAA0B;;AAE1B,qCAAqC;;AAErC;;;iCAGiC;;AAEjC,iBAAiB;;AAEjB;;AAEA,8CAA8C;;AAE9C;;AAEA,iBAAiB;;AAEjB,WAAW;AACX,YAAY;;AAEZ,WAAW;;AAEX,mCAAmC;;AAEnC;;AAEA;;AAEA,UAAU;;AAEV,iBAAiB;;AAEjB,UAAU;;AAEV,iBAAiB;;AAEjB;;;;;;;;;;CAUC;;AAED,iBAAiB;;AAEjB,WAAW;;AAEX,4CAA4C;;AAE5C,UAAU;;AAEV;;AAEA;;AAEA,iBAAiB;;AAEjB,UAAU;AACV,WAAW;;AAEX,YAAY;AACZ,sBAAsB;AACtB,kBAAkB;;AAElB,iBAAiB;;AAEjB,cAAc;AACd,eAAe;;AAEf;2BAC2B;;AAE3B;;AAEA;;AAEA,0BAA0B;AAC1B,aAAa;;AAEb,KAAK;AACL,SAAS;;AAET;;AAEA;;AAEA,sBAAsB;AACtB,aAAa;;AAEb,QAAQ;AACR,SAAS;;AAET;;AAEA;;AAEA,uBAAuB;AACvB,aAAa;;AAEb,MAAM;AACN,QAAQ;;AAER;;AAEA;;AAEA,sBAAsB;AACtB,aAAa;;AAEb,OAAO;AACP,QAAQ;;AAER;;AAEA;;AAEA;;AAEA,sBAAsB;;AAEtB;;AAEA;;AAEA,wBAAwB;;AAExB;;AAEA;;AAEA,mDAAmD;;AAEnD;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,WAAW,wBAAwB,EAAE;;EAErC,WAAW,4BAA4B,EAAE;;EAEzC,WAAW,4BAA4B,EAAE;;EAEzC,WAAW,6BAA6B,EAAE;;EAE1C,WAAW,6BAA6B,EAAE;;EAE1C,WAAW,6BAA6B,EAAE;;EAE1C,WAAW,6BAA6B,EAAE;;AAE5C;;AAEA,mDAAmD;;AAEnD;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,WAAW,wBAAwB,EAAE;;EAErC,WAAW,4BAA4B,EAAE;;EAEzC,WAAW,4BAA4B,EAAE;;EAEzC,WAAW,6BAA6B,EAAE;;EAE1C,WAAW,6BAA6B,EAAE;;AAE5C;;AAEA,2CAA2C;;AAE3C;;AAEA,YAAY;AACZ,sBAAsB;AACtB,QAAQ;;AAER;;AAEA;;AAEA,UAAU;AACV,WAAW;;AAEX,iBAAiB;;AAEjB,0BAA0B;;AAE1B,wCAAwC;;AAExC,8BAA8B;;AAE9B;;AAEA;;AAEA,mBAAmB;;AAEnB;;AAEA;;AAEA,mBAAmB;;AAEnB;;AAEA;;AAEA;;AAEA,uBAAuB;AACvB,WAAW;;AAEX;;AAEA;;AAEA,2BAA2B;AAC3B,SAAS;;AAET;;AAEA;;AAEA,iDAAiD;;AAEjD;;AAEA;;AAEA,SAAS;AACT,iBAAiB;;AAEjB;;AAEA;;AAEA,mBAAmB;;AAEnB;;AAEA;;AAEA,cAAc;;AAEd;;AAEA;;AAEA,cAAc;;AAEd;;AAEA;;AAEA,yBAAyB;;AAEzB;;AAEA","sourcesContent":[":root {\n  --pink: #f2c4c4;\n  --peach: #f9e1be;\n  --mint: #bff1db;\n  --lavender: #d5d1fd;\n\n  --text: #3b3b55;\n  --shadow: rgba(0, 0, 0, 0.08);\n}\n\n.education-loader {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  /* White (or remove completely for transparent) */\n  background: #ffffff;\n\n  /* If you want transparent instead, use:\n  background: transparent;\n  */\n}\n\n/* ---------------- FLOATING EQUATIONS ---------------- */\n\n.floating-elements{\n    position:absolute;\n    inset:0;\n    overflow:hidden;\n    pointer-events:none;\n}\n\n.equation {\n  position: absolute;\n  font-weight: 700;\n  white-space: nowrap;\n  user-select: none;\n\n  opacity: 0.32;\n\n  text-shadow: 0 0 8px rgba(0, 0, 0, 0.03);\n\n  animation-name: float;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n}\n\n/* Lavender */\n.equation:nth-child(4n + 1) {\n  color: #d5d1fd;\n}\n\n/* Mint */\n.equation:nth-child(4n + 2) {\n  color: #6bc79d;\n}\n\n/* Peach */\n.equation:nth-child(4n + 3) {\n  color: #e2b46a;\n}\n\n/* Pink */\n.equation:nth-child(4n) {\n  color: #e6a0a0;\n}\n\n@keyframes float {\n\n  0% {\n    transform: translateY(20px) rotate(-5deg);\n    opacity: .22;\n  }\n\n  50% {\n    transform: translateY(-20px) rotate(5deg);\n    opacity: .55;\n  }\n\n  100% {\n    transform: translateY(20px) rotate(-5deg);\n    opacity: .22;\n  }\n\n}\n\n/* ---------------- PARTICLES ---------------- */\n\n.particles{\n\nposition:absolute;\ninset:0;\npointer-events:none;\n\n}\n\n.particles span {\n\n  width: 4px;\n  height: 4px;\n\n  border-radius: 50%;\n\n  background: #d5d1fd;\n\n  opacity: .35;\n\n  box-shadow:\n    0 0 8px rgba(213,209,253,.35);\n\n  animation: particle linear infinite;\n\n}\n\n@keyframes particle{\n\n0%{\n\ntransform:\ntranslateY(0)\nscale(.6);\n\nopacity:0;\n\n}\n\n15%{\n\nopacity:.8;\n\n}\n\n80%{\n\nopacity:.8;\n\n}\n\n100%{\n\ntransform:\ntranslateY(-130px)\nscale(1.2);\n\nopacity:0;\n\n}\n\n}\n\n/* ---------------- CARD ---------------- */\n\n.loader-card{\n\nposition:relative;\nz-index:5;\n\nwidth:430px;\n\npadding:55px 45px;\n\nborder-radius:32px;\n\nbackground:rgba(255,255,255,.72);\n\nbackdrop-filter:blur(20px);\n\nborder:1px solid rgba(255,255,255,.5);\n\nbox-shadow:\n\n0 35px 70px rgba(0,0,0,.08),\n0 12px 25px rgba(213,209,253,.30);\n\ntext-align:center;\n\n}\n\n/* ---------------- SPINNER ---------------- */\n\n.math-spinner{\n\nposition:relative;\n\nwidth:130px;\nheight:130px;\n\nmargin:auto;\n\nanimation:rotate 8s linear infinite;\n\n}\n\n.math-spinner::before{\n\ncontent:\"\";\n\nposition:absolute;\n\ninset:18px;\n\nborder-radius:50%;\n\nbackground:\n\nconic-gradient(\n\nvar(--lavender),\nvar(--mint),\nvar(--peach),\nvar(--pink),\nvar(--lavender)\n\n);\n\nfilter:blur(16px);\n\nopacity:.55;\n\nanimation:rotate 10s linear infinite reverse;\n\nz-index:-1;\n\n}\n\n.math-spinner span{\n\nposition:absolute;\n\nwidth:54px;\nheight:54px;\n\ndisplay:flex;\njustify-content:center;\nalign-items:center;\n\nborder-radius:50%;\n\nfont-size:28px;\nfont-weight:700;\n\nbox-shadow:\n0 10px 25px rgba(0,0,0,.12);\n\n}\n\n.math-spinner span:nth-child(1){\n\nbackground:var(--lavender);\ncolor:#5b4bc0;\n\ntop:0;\nleft:38px;\n\n}\n\n.math-spinner span:nth-child(2){\n\nbackground:var(--mint);\ncolor:#1f8160;\n\nbottom:0;\nleft:38px;\n\n}\n\n.math-spinner span:nth-child(3){\n\nbackground:var(--peach);\ncolor:#bb7719;\n\nleft:0;\ntop:38px;\n\n}\n\n.math-spinner span:nth-child(4){\n\nbackground:var(--pink);\ncolor:#b35567;\n\nright:0;\ntop:38px;\n\n}\n\n@keyframes rotate{\n\nfrom{\n\ntransform:rotate(0deg);\n\n}\n\nto{\n\ntransform:rotate(360deg);\n\n}\n\n}\n\n/* ---------------- CALCULATIONS ---------------- */\n\n.number-counter {\n  height: 40px;\n  overflow: hidden;\n  margin: 40px auto 20px;\n  font-size: 30px;\n  font-weight: 700;\n  color: #5d56c6;\n}\n\n.number-track {\n  animation: scrollCalc 12s infinite;\n}\n\n.number-track span {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n}\n\n@keyframes scrollCalc {\n\n  0%,10%   { transform: translateY(0); }\n\n  15%,25%  { transform: translateY(-40px); }\n\n  30%,40%  { transform: translateY(-80px); }\n\n  45%,55%  { transform: translateY(-120px); }\n\n  60%,70%  { transform: translateY(-160px); }\n\n  75%,85%  { transform: translateY(-200px); }\n\n  90%,100% { transform: translateY(-240px); }\n\n}\n\n/* ---------------- LOADING TEXT ---------------- */\n\n.loading-text {\n  height: 34px;\n  overflow: hidden;\n  margin-bottom: 26px;\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.message-track {\n  animation: textScroll 15s infinite;\n}\n\n.message-track span {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 34px;\n}\n\n@keyframes textScroll {\n\n  0%,18%   { transform: translateY(0); }\n\n  20%,38%  { transform: translateY(-34px); }\n\n  40%,58%  { transform: translateY(-68px); }\n\n  60%,78%  { transform: translateY(-102px); }\n\n  80%,100% { transform: translateY(-136px); }\n\n}\n\n/* ---------------- DOTS ---------------- */\n\n.loading-dots{\n\ndisplay:flex;\njustify-content:center;\ngap:12px;\n\n}\n\n.loading-dots span{\n\nwidth:12px;\nheight:12px;\n\nborder-radius:50%;\n\nbackground:var(--lavender);\n\nbox-shadow:0 0 12px rgba(213,209,253,.7);\n\nanimation:bounce 1.5s infinite;\n\n}\n\n.loading-dots span:nth-child(2){\n\nanimation-delay:.2s;\n\n}\n\n.loading-dots span:nth-child(3){\n\nanimation-delay:.4s;\n\n}\n\n@keyframes bounce{\n\n0%,80%,100%{\n\ntransform:translateY(0);\nopacity:.45;\n\n}\n\n40%{\n\ntransform:translateY(-12px);\nopacity:1;\n\n}\n\n}\n\n/* ---------------- RESPONSIVE ---------------- */\n\n@media (max-width:768px){\n\n.loader-card{\n\nwidth:90%;\npadding:40px 25px;\n\n}\n\n.math-spinner{\n\ntransform:scale(.9);\n\n}\n\n.loading-text{\n\nfont-size:19px;\n\n}\n\n.number-counter{\n\nfont-size:22px;\n\n}\n\n.equation{\n\nfont-size:18px !important;\n\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
